// extracted by mini-css-extract-plugin
export default {"info":"delete-modal_info__WVdrQ","text":"delete-modal_text__ErjnM","source":"delete-modal_source__qXS4l","button":"delete-modal_button__8+ydk"};